<template>
  <div class="step2">
    <div class="step-serve">
      <h2><span style="color:#f5222d;">*</span>开通产品服务</h2>
      <div class="open" style="flex-wrap: wrap;gap:30px">
        <div>
          <span class="server-label"> 大脑课堂-校园版</span>
          <a-switch :checked="!!(orgSetting.data.productServiceType & 2)" @change="(e) => changeProductService(e, 2)" class="open-serve" />
          <span>{{ orgSetting.data.productServiceType & 2 ? '已开通' : '未开通' }}</span>
        </div>
        <div>
          <span class="server-label">大脑课堂-家庭版</span>
          <a-switch :checked="!!(orgSetting.data.productServiceType & 1)" @change="(e) => changeProductService(e, 1)" />
          <span>{{ orgSetting.data.productServiceType & 1 ? '已开通' : '未开通' }}</span>
        </div>
        <div style="width: 100%; ">
          <span class="server-label">脑智家游小程序</span>
          <a-switch :checked="!!(orgSetting.data.productServiceType & 4)" @change="(e) => changeProductService(e, 4)" />
          <span>{{ orgSetting.data.productServiceType & 4 ? '已开通' : '未开通' }}</span>
        </div>
      </div>

      <h2 class="left-bar">智慧云服务</h2>
      <div class="desc">开通智慧云服务后，机构即可拥有大脑智慧云测训管理平台的使用权。</div>
      <div class="open" :class="{ 'no-server': !orgSetting.data.openCloud }">
        <div>开通智慧云服务</div>
        <div>
          <a-switch :disabled="detail.businessType == 1 || orgSetting.loading" v-model="orgSetting.data.openCloud" class="open-serve" />
          <span>{{ orgSetting.data.openCloud ? '已开通' : '未开通' }}</span>
        </div>
        <div v-show="orgSetting.data.openCloud" style="margin-left: 30px">
          开通自动配课功能
          <a-switch v-model="orgSetting.data.openRecommendCourse" :disabled="orgSetting.loading" />
          <span>{{ orgSetting.data.openRecommendCourse ? '已开通' : '未开通' }}</span>
        </div>
      </div>

      <div v-if="detail.businessType == 1" class="step-serve" style="margin: 42px 0">
        <h2 class="left-bar">脑智云管家服务</h2>
        <div class="desc">开通脑智云管家服务后，机构即可拥有脑智云管家平台使用权，可通过手机号登录</div>
        <div :class="{ 'no-server': !orgSetting.data.openMiniProgram }">
          <span>开通脑智云管家服务</span>
          <a-switch v-model="orgSetting.data.openMiniProgram" :disabled="orgSetting.loading" class="open-serve" @change="orgSettingChange('openMiniProgram')" />
          <span>{{ orgSetting.data.openMiniProgram ? '已开通' : '未开通' }}</span>
        </div>
      </div>
    </div>

    <template v-if="orgSetting.data.openCloud">
      <div class="step-admin">
        <h2 class="left-bar">机构超级管理员</h2>
        <div>
          <a-button v-if="data.length === 0" type="primary" class="add-admin" @click="addAdminFn">添加超级管理员</a-button>
          <a-table :pagination="false" :columns="columns" :data-source="data" :loading="tableLoading">
            <span slot="enabled" slot-scope="text, record">
              <a-switch :disabled="detail.businessType == 1" @change="changeStatus($event, record)" :checked="record.enabled" class="open-serve" checked-children="启用" un-checked-children="禁用" />
            </span>
            <span slot="action" slot-scope="text, record">
              <a-button type="link" @click="addAdminFn({ ...record, _edit: true })">编辑</a-button>
              <a-button type="link" @click="resetPass(record)">重置密码</a-button>
              <a-popconfirm v-if="detail.businessType != 1" title="确认删除?" ok-text="确认" cancel-text="取消" @confirm="delAdminFn(record.id)">
                <a-button type="link" style="color: red">删除</a-button>
              </a-popconfirm>
            </span>
          </a-table>
        </div>
      </div>
      <div>
        <h2 class="left-bar">业务模块</h2>
        <div class="desc">选择该机构需要开通的所有业务功能模块（含其二级机构所需功能模块），机构管理员在智慧云平台为角色配置相关权限时，只能从以下已配置的业务功能模块中选择。</div>
        <Business ref="Business" :orgId="orgId" />
      </div>
    </template>

    <addAdminModal ref="addAdminModal" :orgId="orgId" :isToc="[1].includes(detail.businessType)" />
    <!-- 重置密码 -->
    <a-modal v-model="resetvisible" title="重置密码" @ok="resetOK" @cancel=";(resetvisible = false), (form = {})">
      <a-form-model :rules="rules" ref="ruleForm" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item ref="mobile" label="手机号" prop="mobile">
          <a-input
            v-model.trim="form.mobile"
            disabled
            :maxLength="11"
            @blur="
              () => {
                $refs.mobile.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item ref="password" label="密码" prop="password">
          <a-input-password
            placeholder="请输入新密码"
            v-model="form.password"
            :maxLength="20"
            @blur="
              () => {
                $refs.password.onFieldBlur()
              }
            "
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import Business from './business.vue'
import addAdminModal from './addAdminModal'
import { PasswordReg } from '@/utils/valid'

export default {
  name: 'Step2',
  components: { Business, addAdminModal },
  props: {
    orgId: [String, Number],
    detail: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const checkPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else {
        if (!PasswordReg.test(value)) {
          callback(new Error('8-20位包含字母，数字和特殊字符的密码'))
        } else {
          callback()
        }
      }
    }
    return {
      resetvisible: false,
      rules: {
        password: [{ required: true, validator: checkPass, trigger: 'blur' }],
      },
      form: {},
      data: [],
      tableLoading: false,
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          align: 'center',
        },
        {
          title: '状态',
          dataIndex: 'enabled',
          scopedSlots: { customRender: 'enabled' },
          align: 'center',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
      ],
      orgSetting: {
        loading: false,
        data: {
          openCloud: false,
          openMiniProgram: false,
          openRecommendCourse: false,
          productServiceType: 0,
        },
      },
    }
  },
  activated() {
    this.getAdminList()
    this.$nextTick(() => {
      this.$refs['Business'] && this.$refs['Business'].getTreeData()
    })

    this.data = this.detail.superAdminInfo || []

    for (let orgSettingKey in this.orgSetting.data) {
      if (typeof this.detail[orgSettingKey] !== 'undefined') {
        this.orgSetting.data[orgSettingKey] = this.detail[orgSettingKey]
      }
    }
    this.orgSetting.data.openRecommendCourse = this.detail.recommendCourse

    this.initProductService()

    if (this.detail.businessType == 1 && !this.detail.id) {
      this.orgSetting.data.openCloud = true
      this.orgSettingChange('openCloud', { message: false })
    }
  },
  methods: {
    initProductService() {
      if (this.detail.id) {
        return (this.orgSetting.data.productServiceType = this.detail.productServiceType)
      }
      const orgType = this.detail.orgType
      const productServiceType = this.orgSetting.data.productServiceType

      switch (orgType) {
        case 1:
          this.orgSetting.data.productServiceType = productServiceType | 2
          break
        case 2:
          this.orgSetting.data.productServiceType = productServiceType | 1
          break
        case 0:
          this.orgSetting.data.productServiceType = productServiceType | 1
          break
        case 6:
          this.orgSetting.data.productServiceType = productServiceType | 4
          break
      }
    },
    async changeProductService(open, type) {
      if (!open) {
        const data = await this.checkSubProductService()
        if (data & type) {
          return this.$message.error('请先关闭下级服务')
        }
      }
      const productServiceType = this.orgSetting.data.productServiceType
      this.orgSetting.data.productServiceType = open ? productServiceType | type : productServiceType - type
    },
    async checkSubProductService() {
      const { data } = await this.$http.User.checkSubProductService({ organizationId: this.orgId })
      return data
    },
    resetPass(record) {
      this.form = record
      this.editId = record.adminId
      this.resetvisible = true
    },
    orgSettingChange(type, config = { message: true }) {
      if (type === 'openMiniProgram' && !this.data.length) {
        this.orgSetting.data.openMiniProgram = false
        this.$message.error('请添加超级管理员')
        return
      }
      if (type === 'openMiniProgram') {
        return
      }
      const Params = {
        ...this.orgSetting.data,
        organizationId: this.orgId,
      }
      this.orgSetting.loading = true
      this.$http.Mechanism.updateOrganizationSettings(Params)
        .then((res) => {
          config.message && this.$message.success(res.message)
          if (type === 'openCloud' && this.orgSetting.data.openCloud) {
            this.getAdminList()
          }
          if (typeof type === 'string') {
            this.detail[type] = this.orgSetting.data[type]
          }
        })
        .catch((err) => {
          if (typeof type === 'string') {
            this.orgSetting.data[type] = this.detail[type]
          }
        })
        .finally(() => {
          this.orgSetting.loading = false
        })
    },
    /** 新增/编辑 */
    async addAdminFn(record) {
      await this.$refs['addAdminModal'].show(record)
      this.getAdminList()
    },
    async getAdminList() {
      const { data } = await this.$http.Mechanism.GetSuperAdmin({
        organizationId: this.orgId,
      })
        this.data = [].concat(data.data || [])
    },
    /** 删除 */
    async delAdminFn(id) {
      const fm = new FormData()
      fm.append('id', id)
      const { data } = await this.$http.Mechanism.DeleteOrganizationAdmin(fm)
        this.$message.success('删除成功')
        this.getAdminList()
    
    },
    // 重置密码提交
    resetOK() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let params = this.form
          params.id = this.editId
          this.$http.updatepwd(params).then((res) => {
              this.resetvisible = false
              this.$message.success('修改成功')
              this.getAdminList()
              this.form = {}
          
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getForm() {
      if (!this.$refs['Business']) {
        return undefined
      }
      const params = this.$refs['Business'].getIds()
      return params
    },
    async changeStatus(e, record) {
      const fm = new FormData()
      fm.append('status', e)
      fm.append('id', record.id)
      const data = await this.$http.changeStatusNew(fm)
        this.$message.success('修改成功')
        this.getAdminList()
    },
  },
}
</script>
<style lang="less" scoped>
.step2 {
  .server-label {
    display: inline-block;
    width: 106px;
  }
  .left-bar {
    margin: 20px 0;
    line-height: 1.2;
    border-left: 4px solid @primary-color;
    padding-left: 10px;
    padding-bottom: 1px;
  }

  .desc {
    margin: 10px 0 18px 0;
  }

  .open {
    display: flex;

    .ant-switch:not(.ant-switch-checked) {
      background: #f00;
    }
  }
  ::v-deep .ant-switch {
    margin: 0 10px;
    vertical-align: bottom;
  }
  .step-admin {
    .add-admin {
      margin: 10px 0 20px 0;
    }
  }
}
::v-deep .no-server {
  .ant-switch {
    background: red !important;
  }
}
</style>
